import { FC } from 'react';
import { SideMenuContainer, SideMenuChapter } from './styled';
import { texts } from '../../components/locale';
import { AnimatePresence, Variants } from 'framer-motion';

type Props = {
  timelineAnchor: number;
  isOpen: boolean;
  onClick: (index: number) => void;
};

const menuVariants: Variants = {
  visible: {
    transition: {
      staggerChildren: 0.08,
    },
  },
  hidden: {},
};

const menuItemVatiants: Variants = {
  visible: {
    opacity: 1,
    translateX: 0,
  },
  hidden: {
    opacity: 0,
    translateX: -10,
  },
};

const menuItems = [
  texts.menu_1,
  texts.menu_3,
  texts.menu_5,
  texts.menu_7,
  texts.menu_9,
  texts.menu_11,
  texts.menu_13,
  texts.menu_15,
  texts.menu_17,
];

export const SideMenu: FC<Props> = ({ timelineAnchor, isOpen, onClick }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <SideMenuContainer
          variants={menuVariants}
          animate="visible"
          exit="hidden"
          initial="hidden"
        >
          {menuItems.map((item, index) => (
            <SideMenuChapter
              key={index}
              variants={menuItemVatiants}
              onClick={(event: any) => {
                onClick(index + 1);
              }}
              $isActive={timelineAnchor === index + 1}
            >
              <span>{index + 1}</span> {item}
            </SideMenuChapter>
          ))}
        </SideMenuContainer>
      )}
    </AnimatePresence>
  );
};
